import React, { memo, useContext } from 'react';

import { ListBaseItem, ListBaseItemProps } from '../ListBaseItem/ListBaseItem';
import { ListContext } from '../utils';
import { ParagraphStub, ParagraphStubProps } from '../../Paragraph/ParagraphStub';

const STUB_SIZE_MAP = {
    m: 'm',
    s: 'mc',
    xs: 's',
} as const;

export type ListStubItemProps = Omit<ListBaseItemProps, 'children'> & Pick<ParagraphStubProps, 'width'>;

/**
 * Компонент для элемента списка в состоянии загрузки
 */
export const ListStubItem = memo<ListStubItemProps>(function ListStubItem(props) {
    const { width = 165, className, 'data-testid': dataTestId = 'ListStubItem' } = props;
    const { size } = useContext(ListContext);

    return (
        <ListBaseItem className={className} data-testid={dataTestId}>
            <div>
                <ParagraphStub size={STUB_SIZE_MAP[size]} width={width} />
            </div>
        </ListBaseItem>
    );
});
